<lib-trade-cost-analysis-widget
    [formType$]="type()"
    (tradeCostAnalysisReceived)="submit($event)" />
